import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import PropTypes from "prop-types"
import MobileBackgroundImage from "../../../images/navbar/mobile-menu-background.png"
import VideoBgDesktop from "../../../loader/meniu_desk.mp4"
import VideoBgMobile from "../../../loader/meniu_mobile.mp4"
import Close from "../../../images/close.png"
import "./index.scss"
import { AppLink } from "../../appLink"

export const MobileMenu = ({ menuObject, closeMenu, isOpen, ...props }) => {
  // console.log(menuObject)

  const getStyle = () => {
    return {
      maxHeight: (isOpen ? "100vh" : 0),
      display: (isOpen ? "block" : "none"),
      visibility: (isOpen ? "visible" : "hidden"),
      overflow: (isOpen ? "" : "hidden"),
      height: (isOpen ? "" : 0)
    }
  }

  const getGraphicBackground = () => {
    return {
      backgroundImage: `url('${MobileBackgroundImage}')`
    }
  }

  const onLinkClicked = (path) => (e) => {
    // if (globalHistory && globalHistory.location && globalHistory.location.pathname === path) {
    closeMenu()
    // }
  }

  return <div className="app-mobile-menu container-fluid" style={getStyle()}>
    <div className="app-mobile-menu-content">
      <div className={`graphic-background row ${!isOpen ? "closed" : ""}`}>
        {isOpen &&
        <div>
          <video webkit-playsinline="true" autoPlay muted loop playsInline preload="auto" src={VideoBgDesktop} className="video-bg d-none d-sm-block"/>
          <video webkit-playsinline="true" autoPlay muted loop playsInline preload="auto" src={VideoBgMobile} className="video-bg d-block d-sm-none"/>
        </div>
        }
        {/*<div className="bird1"></div>*/}
        {/*<div className="bird2"></div>*/}
        <div className="container">
          {isOpen && <div className="row d-flex justify-content-end close-button-row">
            <div className="col-auto close-button-col p-0">
              <button className="close-button" onClick={closeMenu}>
                <img src={Close} alt="close-icon"/>
              </button>
            </div>
          </div>}
          <div className="col-12 col-sm-8">
            <div className="row text-uppercase menu-links">
              {!menuObject.promo_campaign_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/promo-campaign"
                         onClick={onLinkClicked("/promo-campaign")}
                         activeClassName="selected">
                  {/*PROMO CAMPAIGN*/}
                  {menuObject.promo_campaign_label}
                </AppLink>
              </div>}
              {!menuObject.products_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/our-chocolate"
                         onClick={onLinkClicked("/our-chocolate")}
                         activeClassName="selected">
                  {/*Our Chocolate*/}
                  {menuObject.products_label}
                </AppLink>
              </div>}
              {!menuObject.what_makes_heidi_unique_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/what-makes-heidi-unique"
                         onClick={onLinkClicked("/what-makes-heidi-unique")}
                         activeClassName="selected">
                  {/*What makes HEIDI unique*/}
                  {menuObject.what_makes_heidi_unique_label}
                </AppLink>
              </div>}
              {!menuObject.shops_page_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/shops"
                         onClick={onLinkClicked("/shops")}
                         activeClassName="selected">
                  {/*DE-AT Shops page*/}
                  {menuObject.shops_page_label}
                </AppLink>
              </div>}
              {!menuObject.chocolate_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/create-your-own-heidi"
                         onClick={onLinkClicked("/create-your-own-heidi")}
                         activeClassName="selected">
                  {/*Create your own HEIDI*/}
                  {menuObject.chocolate_label}
                </AppLink>
              </div>}
              {!menuObject.online_shop_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/buy-heidi-online"
                         onClick={onLinkClicked("/buy-heidi-online")}
                         activeClassName="selected">
                  {/*Buy HEIDI online*/}
                  {menuObject.online_shop_label}
                </AppLink>
              </div>
              }
              {!menuObject.chocolate_lover_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/loyalty"
                         onClick={onLinkClicked("/loyalty")}
                         activeClassName="selected">
                  {/*Become a chocolate lover*/}
                  {menuObject.chocolate_lover_label}
                </AppLink>
              </div>}
              {!menuObject.careers_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/careers"
                         onClick={onLinkClicked("/careers")}
                         activeClassName="selected">
                  {/*Careers*/}
                  {menuObject.careers_label}
                </AppLink>
              </div>}
              {!menuObject.contact_disabled && <div className="col-12 text-center">
                <AppLink className="mobile-menu-link" pageContext={props.pageContext}
                         to="/contact"
                         onClick={onLinkClicked("/contact")}
                         activeClassName="selected"
                         activeStyle={{ color: "white" }}>
                  {/*Contact*/}
                  {menuObject.contact_label}
                </AppLink>
              </div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

MobileMenu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  menuObject: PropTypes.shape({
    careers_disabled: PropTypes.bool,
    careers_label: PropTypes.string,
    chocolate_disabled: PropTypes.bool,
    chocolate_label: PropTypes.string,
    chocolate_lover_label: PropTypes.string,
    chocolate_lover_disabled: PropTypes.bool,
    contact_disabled: PropTypes.bool,
    contact_label: PropTypes.string,
    online_shop_disabled: PropTypes.bool,
    online_shop_label: PropTypes.string,
    products_disabled: PropTypes.bool,
    products_label: PropTypes.string,
    promo_campaign_disabled: PropTypes.bool,
    promo_campaign_label: PropTypes.string,
    what_makes_heidi_unique_disabled: PropTypes.bool,
    what_makes_heidi_unique_label: PropTypes.string,
    shops_page_disabled: PropTypes.bool,
    shops_page_label: PropTypes.string
  }).isRequired
}
